import { Auth0Provider } from "@auth0/auth0-react";
import { PropsWithChildren, useContext } from "react";
import { Nullable } from "../../app/types";
import { scopes } from "./scopes";
import { useNavigate } from "react-router-dom";
import { getLastPathname } from "./utils";
import { ConfigContext } from "../config/context";

export const WithAuth = ({
  children,
}: PropsWithChildren<any>): Nullable<JSX.Element> => {
  const navigate = useNavigate();
  const config = useContext(ConfigContext);

  const handleRedirect = () => {
    const lastPathName = getLastPathname();
    if (!lastPathName) return;
    navigate(lastPathName);
  };

  if (config.authDomain && config.clientId) {
    return (
      <Auth0Provider
        domain={config.authDomain!}
        clientId={config.clientId!}
        redirectUri={window.location.origin}
        onRedirectCallback={handleRedirect}
        useRefreshTokens={true}
        audience={"cloud-api"}
        organization={config.organization}
        scope={scopes.join(" ")}
      >
        {children}
      </Auth0Provider>
    );
  }
  return children;
};
